import { render, staticRenderFns } from "./NavBer.vue?vue&type=template&id=50537045&scoped=true"
import script from "./NavBer.vue?vue&type=script&lang=js"
export * from "./NavBer.vue?vue&type=script&lang=js"
import style0 from "./NavBer.vue?vue&type=style&index=0&id=50537045&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50537045",
  null
  
)

export default component.exports